module.exports = __webpack_public_path__ + "static/media/dashboardActive.dd758ebc.svg";